export const environment = {
  production: false,
  projectName: "AIRCARRIER TEST",
  REST_API_SERVER: "https://aircarrier.test.api.testctsolution.it/api",
  URL_CALLBACK: "https://aircarrier.test.fe.testctsolution.it"
}
